<template>
  <div class="container-wrapper" v-loading="loading">
    <div class="breadcrumb-wrapper">用户列表</div>

    <div class="search-wrapper">
      <el-form :inline="true" :model="queryParam" label-width="74px">
        <el-form-item label="用户ID">
          <el-input
            v-model="queryParam.exactUid"
            placeholder="精准搜索"
            clearable
            style="width: 160px"
          ></el-input>
        </el-form-item>
        <el-form-item label="昵称/姓名">
          <el-input
            v-model="queryParam.fuzzyKeyword"
            placeholder="模糊搜索"
            clearable
            style="width: 160px"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            v-model="queryParam.exactPhone"
            placeholder="精准搜索"
            clearable
            style="width: 160px"
          ></el-input>
        </el-form-item>
        <el-form-item label="角色">
          <el-select
            v-model="queryParam.roleId"
            placeholder="全部"
            style="width: 130px"
          >
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="普通用户" :value="0"></el-option>
            <el-option
              v-for="item in roles"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="性别">
          <el-select
            v-model="queryParam.gender"
            placeholder="全部"
            style="width: 110px"
          >
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="男" :value="1"></el-option>
            <el-option label="女" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="校区">
          <el-select
            v-model="queryParam.unid"
            filterable
            placeholder="全部"
            style="width: 220px"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in campuszones"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="禁言状态">
          <el-select
            v-model="queryParam.isBanned"
            placeholder="全部"
            style="width: 130px"
          >
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="正常" :value="0"></el-option>
            <el-option label="禁言中" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="禁言时长">
          <el-select
            v-model="queryParam.banDurationStatus"
            placeholder="全部"
            style="width: 130px"
          >
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="临时禁言" :value="1"></el-option>
            <el-option label="永久禁言" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="低质状态">
          <el-select
            v-model="queryParam.isLowQuality"
            placeholder="全部"
            style="width: 120px"
          >
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="否" :value="0"></el-option>
            <el-option label="是" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账号身份">
          <el-select
            v-model="queryParam.accountIdentity"
            placeholder="全部"
            style="width: 130px"
          >
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="头号玩家" :value="5"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-button class="margin-left-10" type="primary" @click="clickSearch"
        >搜索</el-button
      >
      <el-button @click="clickReset">重置</el-button>
    </div>

    <div class="action-wrapper">
      <el-button @click="clickTemplateDownload">模版下载</el-button>
      <el-upload
        :show-file-list="false"
        :with-credentials="true"
        accept=".xls,.xlsx"
        :action="actionUrl"
        name="uploadFile"
        :before-upload="beforeUpload"
        :on-success="onSuccess"
        :on-error="onError"
      >
        <el-button type="primary">导入赠送</el-button>
      </el-upload>
    </div>

    <div class="content-wrapper">
      <el-table
        :data="listData"
        border
        @selection-change="handleSelectionChange"
        @sort-change="handleSortChange"
      >
        <el-table-column
          type="selection"
          width="64"
          align="center"
        ></el-table-column>
        <el-table-column
          align="center"
          label="用户ID"
          prop="uid"
          min-width="90"
        ></el-table-column>
        <el-table-column
          align="center"
          label="昵称"
          prop="nickname"
          min-width="120"
        ></el-table-column>
        <el-table-column
          align="center"
          label="姓名"
          prop="name"
          min-width="100"
        ></el-table-column>
        <el-table-column align="center" label="性别" min-width="80">
          <template scope="{ row }">
            <div>{{ genderText(row.gender) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="手机号"
          prop="username"
          min-width="120"
        ></el-table-column>
        <el-table-column
          align="center"
          label="角色"
          prop="rname"
          min-width="100"
        ></el-table-column>
        <el-table-column align="center" label="账号身份" min-width="110">
          <template scope="{ row }">
            <div>{{ accountIdentityText(row.accountIdentity) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="学校"
          prop="schoolName"
          min-width="120"
        ></el-table-column>
        <el-table-column
          align="center"
          label="校区"
          prop="unname"
          min-width="120"
        ></el-table-column>
        <el-table-column
          align="center"
          label="学号/职工号"
          prop="campusIdOrStuId"
          min-width="120"
        ></el-table-column>
        <el-table-column
          align="center"
          label="入学年份"
          prop="enrollmentYear"
          min-width="110"
        ></el-table-column>
        <el-table-column
          align="center"
          label="注册时间"
          prop="registrationDate"
          min-width="165"
          sortable="custom"
        >
          <template scope="{ row }">
            <div>{{ formatDateTime(row.registrationDate) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="最近发贴时间"
          prop="publishTime"
          min-width="165"
          sortable="custom"
        >
          <template scope="{ row }">
            <div>{{ formatDateTime(row.publishTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="禁言状态" min-width="110">
          <template scope="{ row }">
            <div :style="{ color: row.isBanned === 1 ? '#f56c6c' : '' }">
              {{ bannedStatusText(row.isBanned) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="禁言时长" min-width="100">
          <template scope="{ row }">
            <div>{{ banDurationStatusText(row) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="禁言原因"
          prop="banReason"
          min-width="120"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="禁言开始时间"
          prop="banStartTime"
          min-width="165"
          sortable="custom"
        >
          <template scope="{ row }">
            <div>{{ formatDateTime(row.banStartTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="禁言结束时间"
          prop="banEndTime"
          min-width="165"
          sortable="custom"
        >
          <template scope="{ row }">
            <div>{{ formatBanEndTime(row) }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="低质标记状态" min-width="130">
          <template scope="{ row }">
            <div>{{ lowQualityText(row.isLowQuality) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="标记原因"
          prop="lowQualityReason"
          min-width="140"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="标记时间"
          prop="lowQualityMarkTime"
          min-width="165"
          sortable="custom"
        >
          <template scope="{ row }">
            <div>{{ formatDateTime(row.lowQualityMarkTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="300" fixed="right">
          <template scope="{ row }">
            <el-button type="text" @click="clickSingleBan(row)">{{
              row.isBanned === 1 ? "解禁" : "禁言"
            }}</el-button>
            <el-button type="text" @click="clickSingleLowQuality(row)">{{
              row.isLowQuality === 1 ? "取消低质" : "标记低质"
            }}</el-button>
            <el-button type="text" @click="clickSingleIdentity(row)"
              >设置身份</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-wrapper">
      <div class="bottom-action-wrapper">
        <el-button
          type="primary"
          :disabled="selectedRows.length <= 1"
          @click="clickBatchBan"
          >修改批量禁言状态</el-button
        >
        <el-button
          type="primary"
          :disabled="selectedRows.length <= 1"
          @click="clickBatchLowQuality"
          >修改批量低质状态</el-button
        >
        <el-button
          type="primary"
          :disabled="selectedRows.length <= 1"
          @click="clickBatchIdentity"
          >批量设置身份</el-button
        >
      </div>
      <div class="cursor-pagination">
        <el-button
          size="small"
          :disabled="cursorStack.length === 0"
          @click="clickPrevPage"
          >上一页</el-button
        >
        <span class="page-info">第 {{ cursorStack.length + 1 }} 页</span>
        <el-button size="small" :disabled="!hasMore" @click="clickNextPage"
          >下一页</el-button
        >
      </div>
    </div>

    <el-dialog
      title="设置禁言状态"
      size="tiny"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      v-model="banDialog.visible"
    >
      <el-form :model="banDialog.form" label-width="100px">
        <el-form-item label="禁言状态">
          <el-select v-model="banDialog.form.ban" style="width: 220px">
            <el-option label="正常" :value="0"></el-option>
            <el-option label="禁言中" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="禁言时长" v-if="banDialog.form.ban === 1">
          <el-select v-model="banDialog.form.durationType" style="width: 220px">
            <el-option label="1天" value="1d"></el-option>
            <el-option label="7天" value="7d"></el-option>
            <el-option label="30天" value="30d"></el-option>
            <el-option label="90天" value="90d"></el-option>
            <el-option label="永久禁言" value="forever"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="禁言原因"
          v-if="banDialog.form.ban === 1"
          class="reason-form-item"
        >
          <div class="reason-block">
            <el-select
              v-model="banDialog.form.reasonPresetKey"
              clearable
              filterable
              placeholder="请选择事由类型（可选）"
              style="width: 100%"
              @change="onBanReasonPresetKeyChange"
            >
              <el-option
                v-for="opt in reasonPresetOptions"
                :key="opt.key"
                :label="opt.label"
                :value="opt.key"
              ></el-option>
            </el-select>
            <el-input
              v-if="banDialog.form.reasonPresetKey === reasonPresetOtherKey"
              v-model="banDialog.form.reasonExtra"
              type="textarea"
              :rows="2"
              :maxlength="50"
              placeholder="请输入禁言原因（选填，最多50字）"
              show-word-limit
              class="reason-extra-input"
            >
            </el-input>
          </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="banDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="submitBatchBan">确认</el-button>
      </template>
      <div class="dialog-tip">
        * 禁言后禁止发帖、评论，个人主页动态、推荐流不可见；支持点赞和转发。
        <span class="dialog-tip-highlight"
          >若当前用户为禁言状态，则会根据最新操作重新计算</span
        >
      </div>
    </el-dialog>

    <el-dialog
      title="设置低质状态"
      size="tiny"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      v-model="lowQualityDialog.visible"
    >
      <el-form :model="lowQualityDialog.form" label-width="100px">
        <el-form-item label="低质标记状态">
          <el-select
            v-model="lowQualityDialog.form.isLowQuality"
            style="width: 220px"
          >
            <el-option label="否" :value="0"></el-option>
            <el-option label="是" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="标记原因"
          v-if="lowQualityDialog.form.isLowQuality === 1"
          class="reason-form-item"
        >
          <div class="reason-block">
            <el-select
              v-model="lowQualityDialog.form.reasonPresetKey"
              clearable
              filterable
              placeholder="请选择事由类型（可选）"
              style="width: 100%"
              @change="onLowQualityReasonPresetKeyChange"
            >
              <el-option
                v-for="opt in reasonPresetOptions"
                :key="opt.key"
                :label="opt.label"
                :value="opt.key"
              ></el-option>
            </el-select>
            <el-input
              v-if="
                lowQualityDialog.form.reasonPresetKey === reasonPresetOtherKey
              "
              v-model="lowQualityDialog.form.reasonExtra"
              type="textarea"
              :rows="2"
              :maxlength="50"
              placeholder="请输入标记原因（选填，最多50字）"
              show-word-limit
              class="reason-extra-input"
            >
            </el-input>
          </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="lowQualityDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="submitBatchLowQuality"
          >确认</el-button
        >
      </template>
    </el-dialog>

    <el-dialog
      title="设置身份"
      :modal-append-to-body="false"
      v-model="identityDialog.visible"
    >
      <el-form label-width="100px">
        <el-form-item label="账号身份">
          <el-select
            v-model="identityDialog.accountIdentity"
            :disabled="!identityDialog.canSet"
            style="width: 220px"
          >
            <el-option label="头号玩家" :value="5"></el-option>
            <el-option label="无身份" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div
        v-if="!identityDialog.canSet"
        class="dialog-tip dialog-tip-highlight"
      >
        {{ identityBlockReason }}
      </div>
      <template #footer>
        <el-button @click="identityDialog.visible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="identitySubmitting"
          @click="submitIdentity"
          >确认</el-button
        >
      </template>
    </el-dialog>

    <el-dialog
      title="批量设置身份"
      size="large"
      :modal-append-to-body="false"
      v-model="batchIdentityDialog.visible"
    >
      <el-table
        :data="batchIdentityDialog.rows"
        border
        :row-class-name="tableRowClassName"
      >
        <el-table-column
          align="center"
          label="用户ID"
          prop="uid"
          min-width="90"
        ></el-table-column>
        <el-table-column
          align="center"
          label="昵称"
          prop="nickname"
          min-width="130"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          align="center"
          label="姓名"
          prop="name"
          min-width="100"
        ></el-table-column>
        <el-table-column
          align="center"
          label="手机号"
          prop="username"
          min-width="125"
        ></el-table-column>
        <el-table-column
          align="center"
          label="学校"
          prop="schoolName"
          min-width="130"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column align="center" label="当前身份" min-width="110">
          <template scope="{ row }">{{
            accountIdentityText(row.accountIdentity)
          }}</template>
        </el-table-column>
        <el-table-column align="center" label="可设置" min-width="110">
          <template scope="{ row }">
            <el-tooltip
              v-if="!row.canSet"
              effect="dark"
              :content="identityBlockReason"
              placement="top"
            >
              <span class="identity-blocked">无法设置</span>
            </el-tooltip>
            <span v-else>可设置</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="identity-batch-picker">
        <span class="identity-batch-label">账号身份</span>
        <el-select
          v-model="batchIdentityDialog.accountIdentity"
          style="width: 220px"
        >
          <el-option label="头号玩家" :value="5"></el-option>
          <el-option label="无身份" :value="0"></el-option>
        </el-select>
      </div>
      <template #footer>
        <el-button @click="batchIdentityDialog.visible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="identitySubmitting"
          @click="submitBatchIdentity"
          >确认</el-button
        >
      </template>
    </el-dialog>
  </div>
</template>

<script>
// 非真实用户身份：官方号(1)、马甲号(3)、校园主理人(4)，不允许被设置账号身份
const IDENTITY_BLOCKED_VALUES = [1, 3, 4];

export default {
  computed: {
    /** 不可设置身份时的提示原因（列表 tooltip 与弹窗提示共用） */
    identityBlockReason() {
      return "该账号不是真实用户，无法被设置为头号玩家";
    },
    identityRowsTotal() {
      return this.batchIdentityDialog.rows.length;
    },
    identityRowsBlocked() {
      return this.batchIdentityDialog.rows.filter((item) => !item.canSet)
        .length;
    },
  },

  data() {
    return {
      loading: false,
      actionUrl: this.$util.domain + "/adminapi/experienceCard/giveCard/import",
      queryParam: {
        roleId: -1,
        gender: -1,
        unid: "",
        searchKey: "",
        exactUid: "",
        exactPhone: "",
        fuzzyKeyword: "",
        isBanned: -1,
        banDurationStatus: -1,
        isLowQuality: -1,
        accountIdentity: -1,
        sortField: "",
        sortOrder: "",
        pageSize: 10,
      },
      cursor: "",
      nextCursor: "",
      cursorStack: [],
      hasMore: false,
      listData: [],
      roles: [],
      campuszones: [],
      reasonPresetOtherKey: "__other__",
      reasonPresetOptions: [
        { key: "illegal", label: "发布违规内容" },
        { key: "spam", label: "恶意刷屏 / 灌水" },
        { key: "harass", label: "骚扰 / 攻击他人" },
        { key: "ad", label: "广告 / 引流营销" },
        { key: "low_quality", label: "内容低质 / 抄袭" },
        { key: "__other__", label: "其他（自定义输入）" },
      ],
      selectedRows: [],
      banDialog: {
        visible: false,
        form: {
          ban: 1,
          durationType: "1d",
          reasonPresetKey: "",
          reasonExtra: "",
        },
      },
      lowQualityDialog: {
        visible: false,
        form: {
          isLowQuality: 1,
          reasonPresetKey: "",
          reasonExtra: "",
        },
      },
      identityDialog: {
        visible: false,
        accountIdentity: 5,
        canSet: true,
        row: null,
      },
      batchIdentityDialog: {
        visible: false,
        accountIdentity: 5,
        rows: [],
      },
      identitySubmitting: false,
    };
  },

  mounted() {
    this.queryPrivilegeRoles();
    this.queryAllcampuszones();
    if (this.$route.query.uid) this.queryParam.exactUid = this.$route.query.uid;
    this.queryList();
  },

  methods: {
    tableRowClassName(row, index) {
      if (!row.canSet) {
        return "disableCanSet";
      }
    },
    // 原型便签说明：黄色便签只保留为开发备注，不在页面上展示。
    queryPrivilegeRoles() {
      this.$http({
        url: this.$util.domain + "/adminapi/privilege/v1/queryAll",
        method: "GET",
      })
        .then((result) => {
          if (result.body.data && result.body.data.length) {
            this.roles = result.body.data.map((item) => ({
              label: item.name,
              value: item.id,
            }));
          } else {
            this.roles = [];
          }
        })
        .catch(() => {
          this.roles = [];
        });
    },
    queryAllcampuszones() {
      this.$http({
        url: this.$util.domain + "/adminapi/v1/basicTools/allCampusZones",
        method: "GET",
      })
        .then((result) => {
          if (result.body.data && result.body.data.length) {
            this.campuszones = result.body.data.map((item) => ({
              label: item.name,
              value: item.unid,
            }));
          } else {
            this.campuszones = [];
          }
        })
        .catch(() => {
          this.campuszones = [];
        });
    },
    buildQueryBody() {
      var body = {
        pageSize: this.queryParam.pageSize,
      };
      if (this.cursor) {
        body.cursor = this.cursor;
      }
      var exactUid = String(this.queryParam.exactUid || "").trim();
      var exactPhone = String(this.queryParam.exactPhone || "").trim();
      var fuzzyKeyword = String(this.queryParam.fuzzyKeyword || "").trim();
      if (exactUid !== "") {
        body.exactUid = Number(exactUid);
      }
      if (exactPhone !== "") {
        body.exactPhone = exactPhone;
      }
      if (fuzzyKeyword !== "") {
        body.searchKey = fuzzyKeyword;
      }
      if (this.queryParam.roleId !== -1) {
        body.roleId = Number(this.queryParam.roleId);
      }
      if (this.queryParam.gender !== -1) {
        body.gender = Number(this.queryParam.gender);
      }
      if (
        this.queryParam.unid !== "" &&
        this.queryParam.unid !== null &&
        this.queryParam.unid !== undefined
      ) {
        body.unid = Number(this.queryParam.unid);
      }
      if (this.queryParam.isBanned !== -1) {
        body.isBanned = Number(this.queryParam.isBanned);
      }
      if (this.queryParam.banDurationStatus !== -1) {
        body.banDurationStatus = Number(this.queryParam.banDurationStatus);
      }
      if (this.queryParam.isLowQuality !== -1) {
        body.isLowQuality = Number(this.queryParam.isLowQuality);
      }
      // 账号身份：0-普通用户 5-头号玩家；-1 表示全部，不传由后端不过滤
      if (this.queryParam.accountIdentity !== -1) {
        body.accountIdentity = Number(this.queryParam.accountIdentity);
      }
      if (this.queryParam.sortField !== "") {
        body.sortField = Number(this.queryParam.sortField);
      }
      if (this.queryParam.sortOrder !== "") {
        body.sortOrder = this.queryParam.sortOrder;
      }
      return body;
    },
    queryList() {
      this.loading = true;
      this.$http({
        url: this.$util.domain + "/adminapi/privilege/user/v70300/list",
        method: "POST",
        body: JSON.stringify(this.buildQueryBody()),
      })
        .then((res) => {
          var data = (res && res.body && res.body.data) || {};
          this.hasMore = !!data.hasMore;
          this.nextCursor = data.nextCursor || "";
          this.listData = data.content || [];
          this.selectedRows = [];
        })
        .catch(() => {
          this.hasMore = false;
          this.nextCursor = "";
          this.listData = [];
          this.selectedRows = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    clickSearch() {
      this.cursor = "";
      this.nextCursor = "";
      this.cursorStack = [];
      this.queryList();
    },
    clickTemplateDownload() {
      location.href = "https://admin.gxapp.iydsj.com/template/importCard.xls";
    },
    beforeUpload() {
      this.loading = true;
    },
    onSuccess(response) {
      this.loading = false;
      if (response.error !== 10000) {
        this.$util.errorMsg(response.message);
      } else if (response.data && JSON.stringify(response.data) !== "{}") {
        if (response.data.failRecord && response.data.failRecord.length > 0) {
          this.$util.errorMsg(response.data.failRecord.join(";"));
        } else {
          this.$util.successMsg("导入成功");
          this.queryList();
        }
      } else {
        this.$util.successMsg("导入成功");
        this.queryList();
      }
    },
    onError(response) {
      this.loading = false;
      if (response.status === 403) {
        this.SIGNOUT();
        location.href = "/#";
      }
      this.$util.errorMsg("导入失败");
    },
    clickReset() {
      this.queryParam = {
        roleId: -1,
        gender: -1,
        unid: "",
        searchKey: "",
        exactUid: "",
        exactPhone: "",
        fuzzyKeyword: "",
        isBanned: -1,
        banDurationStatus: -1,
        isLowQuality: -1,
        accountIdentity: -1,
        sortField: "",
        sortOrder: "",
        pageSize: 10,
      };
      this.cursor = "";
      this.nextCursor = "";
      this.cursorStack = [];
      this.queryList();
    },
    handleSortChange(sortInfo) {
      var sortFieldMap = {
        registrationDate: 1,
        publishTime: 2,
        banStartTime: 3,
        banEndTime: 4,
        lowQualityMarkTime: 5,
      };
      if (!sortInfo || !sortInfo.prop || !sortInfo.order) {
        this.queryParam.sortField = "";
        this.queryParam.sortOrder = "";
      } else {
        this.queryParam.sortField = sortFieldMap[sortInfo.prop] || "";
        this.queryParam.sortOrder =
          sortInfo.order === "ascending" ? "asc" : "desc";
      }
      this.cursor = "";
      this.nextCursor = "";
      this.cursorStack = [];
      this.queryList();
    },
    clickPrevPage() {
      if (this.cursorStack.length === 0) {
        return;
      }
      this.cursor = this.cursorStack.pop();
      this.queryList();
    },
    clickNextPage() {
      if (!this.hasMore) {
        return;
      }
      this.cursorStack.push(this.cursor);
      this.cursor = this.nextCursor;
      this.queryList();
    },
    formatDateTime(time) {
      if (!time) {
        return "--";
      }
      try {
        return new Date(time).format("yyyy-MM-dd hh:mm:ss");
      } catch (e) {
        return "--";
      }
    },
    formatBanEndTime(row) {
      if (!row) {
        return "--";
      }
      var duration = Number(row.banDuration);
      if (row.isBanned === 1 && !isNaN(duration) && duration === 0) {
        return "--";
      }
      return this.formatDateTime(row.banEndTime);
    },
    genderText(gender) {
      if (gender === 1) {
        return "男";
      }
      if (gender === 0) {
        return "女";
      }
      return "--";
    },
    bannedStatusText(isBanned) {
      return isBanned === 1 ? "禁言中" : "正常";
    },
    banDurationStatusText(row) {
      if (!row || row.isBanned !== 1) {
        return "--";
      }
      var duration = Number(row.banDuration);
      if (isNaN(duration)) {
        return "--";
      }
      if (duration === 0) {
        return "永久禁言";
      }
      if (duration > 0) {
        var secondsPerDay = 24 * 60 * 60;
        var days = Math.round(duration / secondsPerDay);
        if (days <= 0) {
          days = 1;
        }
        return days + "天";
      }
      return "--";
    },
    lowQualityText(isLowQuality) {
      return isLowQuality === 1 ? "是" : "否";
    },
    /** 账号身份：仅 accountIdentity === 5 展示「头号玩家」，其余展示「-」 */
    accountIdentityText(accountIdentity) {
      return Number(accountIdentity) === 5 ? "头号玩家" : "-";
    },
    /** 官方号(1)、马甲号(3)、校园主理人(4) 属于非真实用户，不允许设置身份 */
    isIdentitySettable(accountIdentity) {
      return !IDENTITY_BLOCKED_VALUES.includes(Number(accountIdentity));
    },
    /** 把待设置用户整理为弹窗行：不可设置的排到列表最下方 */
    buildIdentityRows(rows) {
      const settable = [];
      const blocked = [];
      (rows || []).forEach((item) => {
        const row = {
          uid: item.uid,
          nickname: item.nickname,
          name: item.name,
          username: item.username,
          schoolName: item.schoolName,
          accountIdentity: item.accountIdentity,
          canSet: this.isIdentitySettable(item.accountIdentity),
        };
        if (row.canSet) {
          settable.push(row);
        } else {
          blocked.push(row);
        }
      });
      return settable.concat(blocked);
    },
    clickSingleIdentity(row) {
      if (!row) {
        return;
      }
      const canSet = this.isIdentitySettable(row.accountIdentity);
      this.identityDialog.row = row;
      this.identityDialog.canSet = canSet;
      // 已是头号玩家时默认落到「无身份」，便于直接取消
      this.identityDialog.accountIdentity = +row.accountIdentity;
      this.identityDialog.visible = true;
    },
    clickBatchIdentity() {
      if (this.selectedRows.length <= 1) {
        this.$message.warning("请至少选择两条用户数据");
        return;
      }
      this.batchIdentityDialog.rows = this.buildIdentityRows(this.selectedRows);
      this.batchIdentityDialog.accountIdentity = 5;
      this.batchIdentityDialog.visible = true;
    },
    /** 单个设置身份：POST /adminapi/privilege/user/v70380/batchSetAccountIdentity */
    submitIdentity() {
      const row = this.identityDialog.row;
      if (!row || !row.uid) {
        this.$message.warning("用户信息缺失");
        return;
      }
      if (!this.identityDialog.canSet) {
        this.$message.warning(this.identityBlockReason);
        return;
      }
      this.callSetAccountIdentity(
        [row.uid],
        this.identityDialog.accountIdentity,
        () => {
          this.identityDialog.visible = false;
        }
      );
    },
    /** 批量设置身份：仅提交可设置的用户 */
    submitBatchIdentity() {
      const settableRows = this.batchIdentityDialog.rows.filter(
        (item) => item.canSet
      );
      if (!settableRows.length) {
        this.$message.warning("所选用户均无法设置身份");
        return;
      }
      const uids = settableRows.map((item) => item.uid);
      this.callSetAccountIdentity(
        uids,
        this.batchIdentityDialog.accountIdentity,
        () => {
          this.batchIdentityDialog.visible = false;
        }
      );
    },
    callSetAccountIdentity(uids, accountIdentity, onSuccess) {
      this.identitySubmitting = true;
      this.$http({
        method: "POST",
        url:
          this.$util.domain +
          "/adminapi/privilege/user/v70380/batchSetAccountIdentity",
        body: JSON.stringify({
          uids: uids,
          // 5-设为头号玩家，0-取消头号玩家
          accountIdentity: Number(accountIdentity),
        }),
      })
        .then((res) => {
          const body = (res && (res.body || res.data)) || {};
          if (body.error === 10000 || body.error === 0) {
            this.$message.success("操作成功");
            if (typeof onSuccess === "function") {
              onSuccess();
            }
            this.queryList();
            return;
          }
          this.$message.error(body.message || "操作失败");
        })
        .catch(() => {
          this.$message.error("操作失败");
        })
        .finally(() => {
          this.identitySubmitting = false;
        });
    },
    handleSelectionChange(rows) {
      this.selectedRows = rows || [];
    },
    clickBatchBan() {
      if (this.selectedRows.length <= 1) {
        this.$message.warning("请至少选择两条用户数据");
        return;
      }
      this.banDialog.form.reasonPresetKey = "";
      this.banDialog.form.reasonExtra = "";
      this.banDialog.visible = true;
    },
    clickBatchLowQuality() {
      if (this.selectedRows.length <= 1) {
        this.$message.warning("请至少选择两条用户数据");
        return;
      }
      this.lowQualityDialog.form.reasonPresetKey = "";
      this.lowQualityDialog.form.reasonExtra = "";
      this.lowQualityDialog.visible = true;
    },
    clickSingleBan(row) {
      this.selectedRows = [row];
      this.banDialog.form.ban = row.isBanned === 1 ? 0 : 1;
      this.banDialog.form.durationType = "1d";
      this.banDialog.form.reasonPresetKey = "";
      this.banDialog.form.reasonExtra = "";
      this.banDialog.visible = true;
    },
    clickSingleLowQuality(row) {
      this.selectedRows = [row];
      this.lowQualityDialog.form.isLowQuality = row.isLowQuality === 1 ? 0 : 1;
      this.lowQualityDialog.form.reasonPresetKey = "";
      this.lowQualityDialog.form.reasonExtra = "";
      this.lowQualityDialog.visible = true;
    },
    onBanReasonPresetKeyChange() {
      if (this.banDialog.form.reasonPresetKey !== this.reasonPresetOtherKey) {
        this.banDialog.form.reasonExtra = "";
      }
    },
    onLowQualityReasonPresetKeyChange() {
      if (
        this.lowQualityDialog.form.reasonPresetKey !== this.reasonPresetOtherKey
      ) {
        this.lowQualityDialog.form.reasonExtra = "";
      }
    },
    /** 与动态审核一致：仅「其他」用输入框；预设项直接提交对应文案 */
    buildCombinedReasonFromForm(form) {
      var key = form.reasonPresetKey || "";
      var otherKey = this.reasonPresetOtherKey;
      if (!key) {
        return "";
      }
      if (key === otherKey) {
        return String(form.reasonExtra || "")
          .trim()
          .slice(0, 50);
      }
      var opt = this.reasonPresetOptions.find(function (o) {
        return o.key === key;
      });
      return opt ? opt.label : "";
    },
    parseBanDurationSeconds() {
      var map = {
        "1d": 1 * 24 * 60 * 60,
        "7d": 7 * 24 * 60 * 60,
        "30d": 30 * 24 * 60 * 60,
        "90d": 90 * 24 * 60 * 60,
        forever: 0,
      };
      return map[this.banDialog.form.durationType] != null
        ? map[this.banDialog.form.durationType]
        : 0;
    },
    submitBatchBan() {
      var uids = this.selectedRows.map((item) => item.uid);
      if (!uids.length) {
        this.$message.warning("请先选择用户");
        return;
      }
      this.loading = true;
      this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/privilege/user/v70300/batchBan",
        body: JSON.stringify({
          uids: uids,
          ban: this.banDialog.form.ban,
          banDurationSeconds:
            this.banDialog.form.ban === 1 ? this.parseBanDurationSeconds() : 0,
          reason: this.buildCombinedReasonFromForm(this.banDialog.form),
        }),
      })
        .then((res) => {
          if (res.body.error === 10000) {
            this.$message.success("操作成功");
            this.banDialog.visible = false;
            this.queryList();
          } else {
            this.$message.error(res.body.message || "操作失败");
          }
        })
        .catch(() => {
          this.$message.error("操作失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submitBatchLowQuality() {
      var uids = this.selectedRows.map((item) => item.uid);
      if (!uids.length) {
        this.$message.warning("请先选择用户");
        return;
      }
      this.loading = true;
      this.$http({
        method: "POST",
        url:
          this.$util.domain +
          "/adminapi/privilege/user/v70300/batchMarkLowQuality",
        body: JSON.stringify({
          uids: uids,
          isLowQuality: this.lowQualityDialog.form.isLowQuality,
          reason:
            this.lowQualityDialog.form.isLowQuality === 1
              ? this.buildCombinedReasonFromForm(this.lowQualityDialog.form)
              : "",
        }),
      })
        .then((res) => {
          if (res.body.error === 10000) {
            this.$message.success("操作成功");
            this.lowQualityDialog.visible = false;
            this.queryList();
          } else {
            this.$message.error(res.body.message || "操作失败");
          }
        })
        .catch(() => {
          this.$message.error("操作失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cursor-pagination {
  display: flex;
  align-items: center;
  gap: 8px;
}

.page-info {
  font-size: 14px;
  color: #606266;
}

.bottom-action-wrapper {
  display: flex;
  gap: 10px;
}

.action-wrapper {
  gap: 10px;
  margin-bottom: 10px;
}

.dialog-tip {
  margin-top: 6px;
  color: #666;
  font-size: 13px;
  line-height: 20px;
}

.dialog-tip-highlight {
  color: #f56c6c;
}

.reason-form-item >>> .el-form-item__content {
  line-height: normal;
}

.reason-block {
  width: 320px;
}

.reason-extra-input {
  margin-top: 10px;
}

.identity-blocked {
  color: #f56c6c;
  cursor: help;
}

.identity-batch-picker {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
}

.identity-batch-label {
  color: #606266;
  font-size: 14px;
}
</style>

<style>
.disableCanSet {
  opacity: 0.5;
  filter: brightness(0.9);
}
</style>



// WEBPACK FOOTER //
// CommunityUserListing.vue?15eafe86